import { render, staticRenderFns } from "./MainBtn.vue?vue&type=template&id=4511e320&scoped=true"
import script from "./MainBtn.vue?vue&type=script&lang=js"
export * from "./MainBtn.vue?vue&type=script&lang=js"
import style0 from "./MainBtn.vue?vue&type=style&index=0&id=4511e320&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511e320",
  null
  
)

export default component.exports